import { Chip } from "$components/chip";
import { SupplyLevel } from "elephant-web/gql";
import { useIntl } from "react-intl";

export default function SupplyLevelChip({ supplyLevel, quantity }) {
  const { formatMessage } = useIntl();

  if (!supplyLevel) {
    return null;
  }

  const supplyLevelToColorStyleMap = {
    [SupplyLevel.OutOfStock]: "error",
    [SupplyLevel.NeverBeenStocked]: "disabled",
    [SupplyLevel.InStockButNotAtYourLocation]: "error",
    [SupplyLevel.LowStock]: "warning",
    [SupplyLevel.InStock]: "primary",
    IN_STOCK_AT_YOUR_LOCATION: "brand", // TODO: add to GQL enum
  };

  const supplyLevelToChipPostFixText = {
    [SupplyLevel.OutOfStock]: formatMessage({
      id: "dispense.prescription.form.sku.status.outOfStock",
      defaultMessage: "Out of stock",
    }),
    [SupplyLevel.NeverBeenStocked]: formatMessage({
      id: "dispense.prescription.form.sku.status.neverBeenStocked",
      defaultMessage: "Never stocked",
    }),
    [SupplyLevel.InStockButNotAtYourLocation]: formatMessage({
      id: "dispense.prescription.form.sku.status.inStockButNotAtYourLocation",
      defaultMessage: "None at your location",
    }),
    [SupplyLevel.LowStock]: formatMessage({
      id: "dispense.prescription.form.sku.status.lowStock",
      defaultMessage: "in stock",
    }),
    [SupplyLevel.InStock]: formatMessage({
      id: "dispense.prescription.form.sku.status.inStock",
      defaultMessage: "in stock",
    }),
    IN_STOCK_AT_YOUR_LOCATION: formatMessage({
      id: "dispense.prescription.form.sku.status.inStockAtYourLocation",
      defaultMessage: "in stock at your location",
    }),
  };

  const color = supplyLevelToColorStyleMap[supplyLevel];
  const postFixText = supplyLevelToChipPostFixText[supplyLevel];
  let text = postFixText;

  if (quantity) {
    text = `${quantity} ${postFixText}`;
  }

  return <Chip label={text} color={color} />;
}
